import { Component, Input } from '@angular/core';

@Component({
  selector: 'liberro-placeholder-content',
  standalone: false,
  templateUrl: './liberro-placeholder-content.component.html',
  styleUrl: './liberro-placeholder-content.component.less',
})
export class LiberroPlaceholderContentComponent {
  @Input() public icon: string | null = null;
  @Input() public title = '';
}

